/* Wspólne formatowanie cen pochodzących z API Vakanzy. */

export function formatPriceAmount(
  amount,
  maximumFractionDigits = 0
) {
  const numericAmount = Number(amount)

  if (!Number.isFinite(numericAmount)) {
    return ''
  }

  return new Intl.NumberFormat('pl-PL', {
    maximumFractionDigits,
  }).format(numericAmount)
}

export function formatCurrency(currency) {
  return currency === 'PLN'
    ? 'zł'
    : currency ?? ''
}

export function formatCurrentPrice(price) {
  const formattedAmount = formatPriceAmount(
    price?.amount
  )

  if (!formattedAmount) return ''

  const currency = formatCurrency(price?.currency)

  return `${formattedAmount} ${currency} / os.`
}

/**
 * Vakanza wylicza pierwszą transzę jako 30% aktualnej ceny i zaokrągla ją
 * standardowo do pełnych złotych, np. 1618,50 zł → 1619 zł.
 */
export function formatDepositNote(price) {
  const amount = Number(price?.amount)

  if (!Number.isFinite(amount)) return ''

  const depositAmount = Math.round(amount * 0.3)
  const formattedDeposit =
    formatPriceAmount(depositAmount)
  const currency = formatCurrency(price?.currency)

  return `Pierwsza transza to ${formattedDeposit} ${currency}`
}
